import { makeAutoObservable } from 'mobx';

import ApiService from '../services/ApiService';
import ErrorUtil from '../utils/ErrorUtil';
import { formatPrice } from '../utils/NumberUtil';

import { IPrice } from './models/IPrices';

class PriceStore {
  public selectedPrice: IPrice = null;
  public priceItems: IPrice[] = null;
  public noPlans = false;
  public canProceedToPayment = true;

  constructor(private apiService: ApiService) {
    makeAutoObservable<PriceStore, 'apiService'>(this, { apiService: false }, { autoBind: true });
  }

  public resetStore(): void {
    this.selectedPrice = null;
    this.priceItems = null;
    this.noPlans = false;
    this.canProceedToPayment = true;
  }

  public async tryLoadPrices(phoneNumber: string): Promise<void> {
    return this.apiService
      .getPrices(phoneNumber)
      .then((prices) => {
        if (prices && prices.priceplans && prices.priceplans.length) {
          this.setPriceItems(
            prices.priceplans.map((plan) => {
              plan.price = formatPrice(plan.price);
              return plan;
            }),
          );
        }
        this.setNoPlans(this.priceItems.length === 0);
      })
      .catch((error) => {
        ErrorUtil.registerError(error);
        this.setNoPlans(true);
      });
  }

  public updatePrice(code: string | string[]): void {
    this.selectedPrice = this.priceItems.find((price) => price.code === code);
  }

  public setCanProceedToPayment(canProceed: boolean) {
    this.canProceedToPayment = canProceed;
  }

  private setNoPlans(hasNoPlans: boolean): void {
    this.noPlans = hasNoPlans;
  }

  private setPriceItems(priceItems: IPrice[]): void {
    this.priceItems = priceItems;
  }

  get isStepDone(): boolean {
    if (this.selectedPrice == null) {
      return false;
    }
    if (!this.selectedPrice.quotas) {
      return true;
    }

    return this.canProceedToPayment;
  }
}

export default PriceStore;
